import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
const testimonials = [{
  quote: 'Volví a entrenar después de 2 años parada por trabajo y maternidad. En 6 semanas ya tenía rutina, fuerza y fecha para mi primera carrera HYROX. Nunca pensé que iba a ser tan claro el camino.',
  author: 'Valentina S.',
  role: 'Buenos Aires — Mamá, trabaja full time, primera HYROX en camino'
}, {
  quote: 'Dejé de improvisar el primer día que abrí el Pack. Tenía todo ahí: qué hacer, cómo progresar y cómo no abandonar cuando la semana se complica.',
  author: 'Lucía M.',
  role: 'Córdoba — Volvió al entrenamiento con HYROX como objetivo'
}, {
  quote: 'Lo que más me sorprendió fue el sistema anti-abandono. Antes a la tercera semana ya me bajoneaba. Ahora llevo 2 meses consecutivos entrenando y ya inscribí mi primera carrera.',
  author: 'Romina P.',
  role: 'Rosario — 38 años, entrenando en casa con el Pack HYROX Imparable'
}];
export function Testimonials() {
  return <section className="py-20 px-4 bg-brand-dark relative border-y border-gray-800/50" data-id="element-288">
      <div className="max-w-6xl mx-auto" data-id="element-289">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-290">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-brand-black p-8 rounded-2xl border border-gray-800 relative group hover:border-brand-pink/30 transition-colors" data-id="element-291">
              <QuoteIcon className="absolute top-6 right-6 w-8 h-8 text-brand-pink/10 group-hover:text-brand-pink/20 transition-colors" data-id="element-292" />
              <div className="flex gap-1 mb-6" data-id="element-293">
                {[...Array(5)].map((_, j) => <StarIcon key={j} className="w-4 h-4 fill-brand-pink text-brand-pink" data-id="element-294" />)}
              </div>
              <p className="text-gray-300 mb-6 italic leading-relaxed relative z-10" data-id="element-295">
                "{t.quote}"
              </p>
              <div data-id="element-296">
                <p className="text-white font-bold" data-id="element-297">{t.author}</p>
                <p className="text-sm text-brand-copper mt-1 leading-tight" data-id="element-298">
                  {t.role}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}